import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  AddCustomerAttribute,
  addCustomer,
  createCodSetting,
  customerImport,
  customerLoginInfo,
  customerTemplate,
  deleteCustomer,
  deletepickupaddress,
  deletepickupaddressbyId,
  editBankAddress,
  editBillingAddress,
  editBookingSystem,
  editCustomerbyId,
  editInvoiceSystem,
  editRtoaddress,
  editSalesPerson,
  editpickupaddress,
  exportCustomer,
  filterCustomer,
  filterpickupaddressbyId,
  generateCustomerPassword,
  getBankdetailbyId,
  getBillingPeriod,
  getBillingbyId,
  getBookingbyId,
  getCodSetting,
  getCusType,
  getCustomLabelSettings,
  getCustomer,
  getCustomerType,
  getCustomerbyId,
  getInvoiceConfigbyId,
  getManifestationSettings,
  getRtoaddressbyId,
  getSellerType,
  getpickupaddressbyId,
  postBankAddress,
  postBillingAddress,
  postInvoiceSystem,
  postRtoAddress,
  postpikcupAddress,
  pushOracleCustomer,
  resetCustomerPassword,
  syncCustomer,
  toggleCustomerPassword,
  updateCodSetting,
  updateCustomLabelSettings,
  updateManifestationSettings,
} from "../../services/Customers/Customer_services";

const initialValues = {
  customerData: [],
  billingperiodArray: [],
  customerType: [],
  billingAddressData: [],
  rtoAddressData: [],
  customerAccountData: [],
  bankAddressData: [],
  customerTypes: [],
  sellerTypes: [],
};

let crmStore = (set) => ({
  ...initialValues,
  filterCustomer: async (params) => {
    const response = await filterCustomer(params);
    set({ customerData: response });
    return response;
  },
  getBillingPeriod: async (params) => {
    const response = await getBillingPeriod(params);
    set({ billingperiodArray: response?.data?.data });
    return response;
  },
  getCustomerType: async () => {
    const response = await getCustomerType();
    set({ customerType: response?.data?.data });
    return response;
  },
  getCustomer: async (params) => {
    const response = await getCustomer(params);
    set({ customerData: response });
    return response;
  },
  exportCustomer: async (params) => {
    const response = await exportCustomer(params);
    return response;
  },
  customerTemplate: async () => {
    const response = await customerTemplate();
    return response;
  },
  customerImport: async (params) => {
    const response = await customerImport(params);
    return response;
  },
  syncCustomer: async (params) => {
    const response = await syncCustomer(params);
    return response;
  },
  deleteCustomer: async (params) => {
    const response = await deleteCustomer(params);
    return response;
  },
  addCustomer: async (params) => {
    const response = await addCustomer(params);
    return response;
  },
  getCusType: async () => {
    const response = await getCusType();
    set({ customerTypes: response?.data?.data });
    return response;
  },
  getSellerType: async () => {
    const response = await getSellerType();
    set({ sellerTypes: response?.data?.data });
    return response;
  },
  getCustomerbyId: async (params) => {
    const response = await getCustomerbyId(params);
    set({ customerAccountData: response });
    return response;
  },
  pushOracleCustomer: async (params) => {
    const response = await pushOracleCustomer(params);
    return response;
  },
  editCustomerbyId: async (params, data) => {
    const response = await editCustomerbyId(params, data);
    return response;
  },
  editSalesPerson: async (params, params2,data) => {
    const response = await editSalesPerson(params, params2,data);
    return response;
  },
  postBillingAddress: async (params, data) => {
    const response = await postBillingAddress(params, data);
    return response;
  },
  editBillingAddress: async (params, data) => {
    const response = await editBillingAddress(params, data);
    return response;
  },
  getBillingbyId: async (params) => {
    const response = await getBillingbyId(params);
    set({ billingAddressData: response });
    return response;
  },
  getBankdetailbyId: async (params) => {
    const response = await getBankdetailbyId(params);
    set({ bankAddressData: response });
    return response;
  },
  postBankAddress: async (params, data) => {
    const response = await postBankAddress(params, data);
    return response;
  },
  editBankAddress: async (params, data) => {
    const response = await editBankAddress(params, data);
    return response;
  },
  getBookingbyId: async (params) => {
    const response = await getBookingbyId(params);
    return response;
  },
  editBookingSystem: async (data) => {
    const response = await editBookingSystem(data);
    return response;
  },
    getInvoiceConfigbyId: async (data) => {
    const response = await getInvoiceConfigbyId(data);
    return response;
  },
  postInvoiceSystem: async (params,data) => {
    const response = await postInvoiceSystem(params,data);
    return response;
  },
    editInvoiceSystem: async (params,data) => {
    const response = await editInvoiceSystem(params,data);
    return response;
  },
  getpickupaddressbyId: async (params, params2) => {
    const response = await getpickupaddressbyId(params, params2);
    return response;
  },
  filterpickupaddressbyId: async (params, params2) => {
    const response = await filterpickupaddressbyId(params, params2);
    return response;
  },
  postpikcupAddress: async (params, data) => {
    const response = await postpikcupAddress(params, data);
    return response;
  },
  deletepickupaddressbyId: async (params,params2) => {
    const response = await deletepickupaddressbyId(params,params2);
    return response;
  },
  editpickupaddress: async (params, params2, data) => {
    const response = await editpickupaddress(params, params2, data);
    return response;
  },
  getRtoaddressbyId: async (params) => {
    const response = await getRtoaddressbyId(params);
    set({ rtoAddressData: response });
    return response;
  },
  postRtoAddress: async (params,data) => {
    const response = await postRtoAddress(params,data);
    return response;
  },
  editRtoaddress: async (params,data) => {
    const response = await editRtoaddress(params,data);
    return response;
  },
  customerLoginInfo: async (params,data) => {
    const response = await customerLoginInfo(params,data);
    return response;
  },
  resetCustomerPassword: async (params) => {
    const response = await resetCustomerPassword(params);
    return response;
  },
  AddCustomerAttribute: async (data) => {
    const response = await AddCustomerAttribute(data);
    return response;
  },
  toggleCustomerPassword: async (params,data) => {
    const response = await toggleCustomerPassword(params,data);
    return response;
  },
  generateCustomerPassword: async () => {
    const response = await generateCustomerPassword();
    return response;
  },
  deletepickupaddress: async (params, data) => {
    const response = await deletepickupaddress(params, data);
    return response;
  },
  createCodSetting: async (accountNumber, data) => {
    const response = await createCodSetting(accountNumber, data);
    return response;
  },
  updateCodSetting: async (accountNumber, data) => {
    const response = await updateCodSetting(accountNumber, data);
    return response;
  },
  getCodSetting: async (accountNumber) => {
    const response = await getCodSetting(accountNumber);
    return response;
  },
  getCustomLabelSettings: async (customerAccount) => {
    const response = await getCustomLabelSettings(customerAccount);
    return response;
  },
  updateCustomLabelSettings: async (data) => {
    const response = await updateCustomLabelSettings(data);
    return response;
  },
      getManifestationSettings: async (customerAccount) => {
    const response = await getManifestationSettings(customerAccount);
    return response;
  },
  updateManifestationSettings: async (data) => {
    const response = await updateManifestationSettings(data);
    return response;
  },
});

crmStore = devtools(crmStore);

export const useCrmStore = create(crmStore);
